import React, { createContext, FC, PropsWithChildren, useState } from 'react';

export interface SideBarVisibilityContext {
  hideSideBar: boolean;
  setHideSideBar: (hasError: boolean) => void;
  setExpandMobileSideBarMenu: (isExpanded: boolean) => void;
  toggleMobileSideBarMenu: () => void;
  expandMobileSideBarMenu: boolean;
}

export const SideBarVisibilityContext = createContext<SideBarVisibilityContext>(null);

const SideBarVisibilityContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [hideSideBar, setHideSideBar] = useState<boolean>(false);
  const [expandMobileSideBarMenu, setExpandMobileSideBarMenu] = useState<boolean>(false);

  const toggleMobileSideBarMenu = () => {
    setExpandMobileSideBarMenu((prevState) => !prevState);
  };

  return (
    <SideBarVisibilityContext.Provider
      value={{
        hideSideBar,
        setHideSideBar,
        toggleMobileSideBarMenu,
        expandMobileSideBarMenu,
        setExpandMobileSideBarMenu,
      }}
    >
      {children}
    </SideBarVisibilityContext.Provider>
  );
};

export default SideBarVisibilityContextProvider;
